import { render, staticRenderFns } from "./select-customer.vue?vue&type=template&id=43003c50&scoped=true"
import script from "./select-customer.vue?vue&type=script&lang=js"
export * from "./select-customer.vue?vue&type=script&lang=js"
import style0 from "./select-customer.vue?vue&type=style&index=0&id=43003c50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43003c50",
  null
  
)

export default component.exports